var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenewableEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80B7B342-5A94-4138-A878-8AE8009F7371") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plaza_schedule_v1",
    transform: "translate(-964.000000, -218.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.170732,222.708738 L972.780488,227.805825 C972.487805,228.145631 972.731707,228.728155 973.219512,228.728155 L975.756098,228.728155 L973.95122,233.145631 C973.853659,233.38835 974.146341,233.533981 974.341463,233.38835 L979.170732,227.61165 C979.512195,227.223301 979.219512,226.592233 978.682927,226.592233 L976.439024,226.592233 L977.804878,223.097087 C977.902439,222.708738 977.414634,222.417476 977.170732,222.708738 Z M984.731707,231.058252 C984.243902,230.815534 983.658537,231.009709 983.414634,231.495146 C982.04878,234.262136 979.170732,236.106796 976.097561,236.106796 C972.097561,236.106796 968.780488,233.242718 968.097561,229.456311 L970.195122,229.262136 L966.878049,225.621359 L964,229.796117 L966.146341,229.601942 C966.926829,234.359223 971.073171,238 976.097561,238 C979.95122,238 983.512195,235.76699 985.170732,232.320388 C985.414634,231.834951 985.219512,231.252427 984.731707,231.058252 Z M986,226.349515 C985.219512,221.592233 981.073171,218 976.097561,218 C972.243902,218 968.829268,220.135922 967.073171,223.533981 C966.829268,224.019417 967.02439,224.601942 967.512195,224.84466 C968,225.087379 968.585366,224.893204 968.829268,224.407767 C970.195122,221.640777 973.02439,219.941748 976.097561,219.941748 C980.04878,219.941748 983.365854,222.805825 984.097561,226.543689 L982.390244,226.68932 L985.463415,230.135922 L988,226.203883 L986,226.349515 Z",
    id: "Renewable-energy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewableEnergy);
export default __webpack_public_path__ + "static/media/Renewable_energy.8fe9920245395ec7c69f8f7da090f421.svg";
export { ForwardRef as ReactComponent };